import React from 'react';
import { useSelector } from 'react-redux';
import AppRegion from '@/types/app-region';
import { ReduxState } from '@/redux/modules/types';
import { getUserAppRegion } from '@/utils/users';
import TaxAnalysisInputsContainerUS from './TaxAnalysisInputsContainerUS';
import TaxAnalysisInputsContainerCA from './TaxAnalysisInputsContainerCA';

interface TaxAnalysisInputsContainerProps {
  readOnly?: boolean;
}

// Map of regions to their corresponding input components
const REGION_COMPONENT_MAP: Record<AppRegion, React.ComponentType<TaxAnalysisInputsContainerProps>> = {
  [AppRegion.US]: TaxAnalysisInputsContainerUS,
  [AppRegion.CAN]: TaxAnalysisInputsContainerCA,
};

/**
 * Wrapper component that renders the appropriate tax inputs container based on user's region.
 * Only renders for US or CAN regions.
 */
const TaxAnalysisInputsContainer: React.FC<TaxAnalysisInputsContainerProps> = ({ readOnly = false }) => {
  const user = useSelector((state: ReduxState) => state.auth.user);
  const userRegion = getUserAppRegion(user);

  const InputsComponent = userRegion ? REGION_COMPONENT_MAP[userRegion] : undefined;

  return InputsComponent ? <InputsComponent readOnly={readOnly} /> : null;
};

export default TaxAnalysisInputsContainer;
